import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  sender_name: '發送者姓名',
  sender_wallet: '發送者錢包',
  last_n_digits: '交易參考號',
  invoice_flow__multi_time_remainin: '剩餘時間',
  invoice_flow__multi_or: '或',
  invoice_flow__multi_open_app: '在應用程式中開啟',
  invoice_flow__multi_return_button: '返回網站',
  invoice_flow__card_transfer_button: '確認',
  invoice_flow__multi_upi_qr_step_1: '掃描或複製上方二維碼',
  invoice_flow__multi_upi_qr_step_2: '請完成支付',
  invoice_flow__multi_step_3: '填寫 <b>{attributes}</b> 後點擊「確認」按鈕',
  invoice_flow__multi_upi_qr_mob_step_1: '掃描上方二維碼，或點擊「在應用程式中開啟」按鈕',
  invoice_flow__multi_bank_transfer_step_1: '複製收款資訊',
  invoice_flow__multi_bank_transfer_step_2: '請完成支付',
  invoice_flow__card_transfer_step_1: '複製收款資訊',
  invoice_flow__card_transfer_step_2:
    '請轉帳指定金額（可使用您的銀行帳戶，或前往最近的銀行或自助終端）',
  invoice_flow__card_transfer_step_3: '填寫確認資訊：<b>{attributes}</b>',
  invoice_flow__card_transfer_step_4: '轉帳完成後，點擊 <b>「確認」</b>',
};
